import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { fleetPageBreadcrumbs } from '../../../config/breadcrumbs';
import { useFeeService } from '@/pages/Fleet/Businesses/hooks';
import { useServiceFormOptions } from '../../hooks';
import { useNavigate, useParams } from 'react-router-dom';
import ServiceFormView from '../../components/ServiceFormView';
import { Edit as EditIcon } from '@mui/icons-material';
import { useMemo, useEffect } from 'react';
import {
  NavigateLinks,
  GlobalButton,
  BackToModuleButton,
} from '@/components';

const ViewService = () => {
  const params = useParams();
  const serviceId = params.serviceId ?? '';
  const navigate = useNavigate();
  const hasValidServiceId = !!serviceId?.trim();
  const { feeService, isLoading, error } = useFeeService({ feeServiceId: serviceId });
  const { vehicleTypesLoading, serviceTypesLoading } = useServiceFormOptions();

  useEffect(() => {
    if (!hasValidServiceId || error) {
      navigate('/fleet/services');
    }
  }, [hasValidServiceId, error, navigate]);

  const breadcrumbs = useMemo<NavigateLink[]>(() => {
    const base = fleetPageBreadcrumbs(navigate);
    return [
      ...base,
      { label: 'Servicios', onClick: () => navigate('/fleet/services') },
    ];
  }, [navigate]);

  const handleEdit = () => {
    navigate(`/fleet/services/${serviceId}/edit`);
  };

  const shouldRedirect = !hasValidServiceId || error;
  if (shouldRedirect) return null;

  const actualPage = feeService?.name ?? 'Ver servicio';

  return (
    <section className="w-full h-full flex flex-col gap-[25px]">
      <NavigateLinks actualPage={actualPage} breadcrumbs={breadcrumbs} />
      <div className="flex justify-end gap-5">
        <BackToModuleButton breadcrumbs={breadcrumbs} />
        <GlobalButton
          variant={GlobalButtonVariant.secondaryButton}
          action={handleEdit}
        >
          <EditIcon />
          Editar
        </GlobalButton>
      </div>
      <div className="w-full flex rounded-[5px] shadow-[0_0_4px_rgba(0,0,0,0.1)]">
        {isLoading ? (
          <p className="p-[50px] text-gray-600">Cargando...</p>
        ) : (
          <ServiceFormView
            title="Información del servicio"
            serviceName={feeService?.name}
            businessDisplayName={feeService?.commercialBusiness?.name}
            vehicleTypeName={feeService?.vehicleType?.name}
            serviceTypeName={feeService?.serviceType?.name}
            fee={feeService?.fee}
            min={feeService?.min}
            validFrom={feeService?.validFrom ? new Date(feeService.validFrom) : undefined}
            validTo={feeService?.validTo ? new Date(feeService.validTo) : undefined}
            vehicleTypesLoading={vehicleTypesLoading}
            serviceTypesLoading={serviceTypesLoading}
          />
        )}
      </div>
    </section>
  );
};

export default ViewService;
